<template>
  <div class="categories">
    <el-container>
      <el-header height="60px">
        <h2>分类浏览</h2>
        <p>按分类查看工具</p>
      </el-header>
      <el-main>
        <el-row :gutter="20" v-loading="loading">
          <el-col :xs="24" :sm="12" :md="6" v-for="category in categories" :key="category.id">
            <el-card class="category-card" @click="goToCategory(category.id)">
              <template #header>
                <div class="card-header">
                  <el-icon><Folder /></el-icon>
                  <span>{{ category.name }}</span>
                </div>
              </template>
              <p>{{ category.description || '暂无描述' }}</p>
              <div class="tool-count">
                <el-tag type="info">{{ category.tool_count || 0 }} 个工具</el-tag>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <el-empty v-if="categories.length === 0" description="暂无分类" />

        <el-divider />

        <el-row>
          <el-col :span="24">
            <el-card>
              <template #header>
                <div class="card-header">
                  <span>所有工具</span>
                </div>
              </template>
              <p>您也可以查看 <el-link type="primary" @click="$router.push('/tools')">所有工具列表</el-link>。</p>
            </el-card>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { Folder } from '@element-plus/icons-vue'
import { getCategories } from '@/api/categories'
import type { CategoryListItem } from '@/types/category'

const router = useRouter()
const categories = ref<CategoryListItem[]>([])
const loading = ref(false)

onMounted(async () => {
  loading.value = true
  try {
    categories.value = await getCategories()
  } catch (error) {
    console.error('Failed to load categories:', error)
    categories.value = []
  } finally {
    loading.value = false
  }
})

function goToCategory(categoryId: number) {
  router.push({ path: '/tools', query: { category: String(categoryId) } })
}
</script>

<style scoped>
.categories {
  padding: 20px;
}
.category-card {
  cursor: pointer;
  margin-bottom: 20px;
  height: 180px;
}
.category-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
}
.tool-count {
  margin-top: 10px;
}
@media (max-width: 768px) {
  .category-card {
    height: auto;
  }
}
</style>
